export class API {
    
    url="https://spo.handball4all.de/service/if_ticker_data.php";
    private token:string|null;
    private wantAlert:boolean=true;

    constructor() {
        var urlParams = new URLSearchParams(location.search);
        this.token=urlParams.get('token');
    }
    
    public setWantAlert(f: boolean):API {
        this.wantAlert=f;
        return this;
    }
    
    transactAsync(command:string, parent:object, callback:(parent:any, object:any)=>void):void {
        var ajaxRequest = new XMLHttpRequest();
        var result = '{"errorCode": 1, "errorSubCode": 0, "message": "ajax failed" }';
        var outer=this;
        ajaxRequest.onreadystatechange=function() {
            if (ajaxRequest.readyState==4) {
                result = ajaxRequest.responseText;
                try {
                    var resultObject=JSON.parse(result);
                }
                catch (e) {
                    resultObject = { status : 1 };
                }
                if (!Array.isArray(resultObject) && resultObject.status != 0) {
                    if (outer.wantAlert) {
                        alert("statechange "+ajaxRequest.readyState+":" + result);
                    }
                }
                callback(parent, resultObject);
            }
        }
        ajaxRequest.open("POST", this.url+"?token="+this.token+"&cmd="+command, true);
        ajaxRequest.send();
    }
}




// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/API.ts